/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { DependencyIcon } from '../../../../../common/ui/dependency-icon';

export const Icon = (props: { top: number; left: number; color: string }) => (
	<Wrapper top={props.top} left={props.left}>
		<DependencyIcon color={props.color} />
	</Wrapper>
);

const ICON_SIZE = 20;

const wrapperBaseStyles = css({
	position: 'absolute',
	width: `${ICON_SIZE}px`,
	height: `${ICON_SIZE}px`,
	transform: `translate(-${ICON_SIZE / 2}px, -${ICON_SIZE / 2}px)`,
});

const Wrapper = ({
	top,
	left,
	children,
}: {
	top: number;
	left: number;
	children: React.ReactNode;
}) => (
	<div
		css={wrapperBaseStyles}
		// eslint-disable-next-line jira/react/no-style-attribute
		style={{
			top: `${top}px`,

			left: `${left}px`,
		}}
	>
		{children}
	</div>
);
